var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("SearchBannerFormSkeleton")
    : _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-items" },
            [
              _c("SearchBannerCityDropdown", {
                attrs: {
                  "store-namespace": _vm.storeNamespace,
                  "is-desktop": _vm.isDesktop,
                  id: _vm.id + "-city",
                  label: _vm.labels.city,
                  "drawer-config": {
                    title: _vm.labels.cityDrawer,
                    closeText: _vm.labels.cityCloseText,
                  },
                  active: _vm.cityActive,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.cityActive = $event
                  },
                  "city-selected": _vm.handleCitySelect,
                },
              }),
              _vm._v(" "),
              _c("SearchBannerDateCalendar", {
                attrs: {
                  "store-namespace": _vm.storeNamespace,
                  "is-desktop": _vm.isDesktop,
                  id: _vm.id + "-calendar",
                  label: _vm.labels.date,
                  "drawer-config": {
                    title: _vm.labels.dateDrawer,
                    closeText: _vm.labels.dateCloseText,
                  },
                  active: _vm.dateActive,
                  type: _vm.calendarConfig.type,
                  flow: _vm.calendarConfig.flow,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.dateActive = $event
                  },
                  "date-selected": _vm.handleDateSelect,
                },
              }),
              _vm._v(" "),
              _c("SearchBannerAmountDropdown", {
                attrs: {
                  "store-namespace": _vm.storeNamespace,
                  "is-desktop": _vm.isDesktop,
                  id: _vm.id + "-amount",
                  label: _vm.labels.amount,
                  "drawer-config": {
                    title: _vm.labels.amountDrawer,
                    closeText: _vm.labels.amountCloseText,
                  },
                  active: _vm.amountActive,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.amountActive = $event
                  },
                  "amount-selected": _vm.handleAmountSelect,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("button", { attrs: { type: "submit" } }, [
            _c("i", { staticClass: "sd2-icons search" }),
            _vm._v(" "),
            _c("span", { staticClass: "submit-label-mobile" }, [
              _vm._v(_vm._s(_vm.labels.submit)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "submit-label-desktop" }, [
              _vm._v(_vm._s(_vm.$t("10049086.Home_BannerSearchButtonText"))),
            ]),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }